import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTractorQuickInfo extends Layout {
    labelAssignedDriver: Label;
    labelTeamDriver: Label;
    panelDriver1: Panel;
    panelDriver2: Panel;
    panelDrivers: Panel;
    panelTractor: Panel;
    sourceTractor: DataSource;
    textboxAssignedDriverfirstName: Textbox;
    textboxAssignedDrivername: Textbox;
    textboxDispatcher: Textbox;
    textboxId: Textbox;
    textboxOwner: Textbox;
    textboxServiceStatus: Textbox;
    textboxTeamDriverfirstName: Textbox;
    textboxTeamDrivername: Textbox;
}
